(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-fancy-slideshow"] && !Shopify.designMode) return;
  try {
    
class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 100);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-fancy-slideshow')) {
        this.init()
      }
    })
  }

  init () {    
    if (!window.Swiper) return

    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    console.log(sliderElem.dataset.swiperSpacing)

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: Math.round(Number(sliderElem.dataset.swiperSpacing) * .75)
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-testimonial-new"] && !Shopify.designMode) return;
  try {
    
class KsTestimonialsSlider extends HTMLElement {
  constructor () {
    super()
 
    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    setTimeout(() => { 
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
    }, 500)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

}
customElements.define('ks-testimonials-slider', KsTestimonialsSlider)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-whatsapp"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-goal"] && !Shopify.designMode) return;
  try {
    
   (function () {  
    async function insertSection() {

      const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')

      if (cartDrawerItems.classList.contains('is-empty')) return
      if (document.querySelector('#CartDrawer #ks-cart-goal')) return

      const wrapper = document.querySelector('#ks-cart-goal-wrapper')

      cartDrawerItems.insertAdjacentHTML('beforebegin', wrapper.innerHTML) 

      setTimeout(() => {
        const progressBar = document.querySelector('#ks-cart-goal .progress-bar')
        progressBar.style.width = progressBar.dataset.width
      }, 250)

    }
    insertSection()
    
    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#ks-cart-goal-wrapper')
            .replaceWith(newDocument.querySelector('#ks-cart-goal-wrapper'))

          insertSection()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-upsell"] && !Shopify.designMode) return;
  try {
    
   (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#ks-cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.ks-cart-drawer-upsell-list li')) {
        document.querySelector('#ks-cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

    async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #ks-cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#ks-cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.ks-cart-drawer-upsell-list li')) {
        document.querySelector('#ks-cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage()
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.ks-cart-drawer-upsell-list-item').querySelector('.ks-cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#ks-cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#ks-cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#ks-cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#ks-cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-marquee"] && !Shopify.designMode) return;
  try {
    
  class KsMarquee extends HTMLElement {
    constructor() {
      super();

      this.init();

      document.addEventListener('shopify:section:load', (e) => {
        console.log(e.target);
        if (e.target.querySelector('.ks-marquee')) {
          init();
        }
      });
    }

    init() {
      const list = this.querySelector('ul');
      console.log(list);
      const marqueeWidth = list.scrollWidth;
      console.log(list.scrollWidth);
      const marqueeLength = list.querySelectorAll('li').length;

      list.insertAdjacentHTML('beforeEnd', list.innerHTML);

      list.querySelectorAll('li').forEach((item, index) => {
        if (index >= marqueeLength) {
          item.setAttribute('aria-hidden', 'true');
        }
      });

      let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `;
      if (this.dataset.marqueeDirection === 'right') {
        style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `;
      }

      this.insertAdjacentHTML('beforeBegin', style);
    }
  }
  customElements.define('ks-marquee', KsMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-matrix-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".ks-matrix-grid [data-viewport-entered]").forEach((el) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.dataset.viewportEntered = "true";
            observer.unobserve(entry.target);

            if (entry.target.dataset.videoAutoplay === "true") {
              const video = entry.target.querySelector("video");
              if (video) {
                video.muted = true;
                video.play();
              }
            }
          }
        });
      },
      {
        rootMargin: `0px 0px -100px 0px`,
      },
    );

  observer.observe(el);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

      window.addEventListener('scroll', () => {
        if (window.scrollY > top) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.clientHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = 0
        }
      })
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        this.querySelectorAll('img').forEach(elem => {
          elem.src = variantImg
        })
 
        this.querySelectorAll('.price').forEach(elem => {
          if (variantComparePrice.length) {
            elem.classList.add('price--on-sale')
            elem.querySelector('.price__sale .price-item--regular').textContent = variantComparePrice
            elem.querySelector('.price__sale .price-item--sale').textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            elem.querySelector('.price__regular .price-item--regular').textContent = variantPrice
          }
        })

        this.querySelectorAll('button[name="add"]').forEach(btn => {
          if (selectedOption.disabled) {
            btn.disabled = true
            btn.querySelector('span').textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            btn.querySelector('.sold-out-message').classList.add('hidden')
            btn.querySelector('span').textContent = this.dataset.textAddToCart
          }
        })
      })
    }

    handleMainVariantChange () {
      this.mainVariantInput.addEventListener('change', (event) => {
        this.variantSelector.value = this.mainVariantInput.value
        this.variantSelector.dispatchEvent(new Event('change'))
      })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class KsLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.ks-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.ks-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('ks-lookbook', KsLookBook)

  } catch(e) { console.error(e); }
})();
})();
